import Util from './Util';

export default (userData = {}) => {
	const {
		ContactId = null,
		FullName = '',
		FirstName = '',
		MiddleName = '',
		LastName = '',
		Prefix = '',
		Suffix = '',
		Company = '',
		Department = '',
		Title = '',
		Email = '',
		Phone = '',
		PhoneExt = '',
		Street1 = '',
		Street2 = '',
		Street3 = '',
		City = '',
		State = '',
		Zip = '',
		ZipAddOn = '',
		PostalCode = '',
		CountryId = 203,
		CountryCode = 'US',
		Province = '',
		CostCode = '<None>',
		CostCodeId = -1,
		ReferenceNumber = '',
		CreationTime = '',
		LastUpdateTime = '',
		IsPOBox = false,
	} = userData;

	return {
		ContactId,
		FullName: Util.getContactFullName(Prefix, userData),
		FirstName,
		MiddleName,
		LastName,
		Prefix,
		Suffix,
		Company,
		Department,
		Title,
		Email,
		Phone,
		PhoneExt,
		Street1,
		Street2,
		Street3,
		City,
		State,
		Zip,
		ZipAddOn,
		PostalCode,
		CountryId,
		CountryCode,
		Province,
		CostCode,
		CostCodeId,
		ReferenceNumber,
		CreationTime,
		LastUpdateTime,
		IsPOBox,
	};
};
